module.exports = __webpack_public_path__ + "static/media/img-nasm-logo.03b42df3.svg";